import HeaderCharmType from '../store/schema/HeaderCharmType';
import toggleCharm from '../actions/toggleCharm';
import { orchestrator } from 'satcheljs';
import showQuickOptionsAction from 'owa-options-actions/lib/showQuickOptions';

export default orchestrator(showQuickOptionsAction, function showSettings() {
    toggleCharm(HeaderCharmType.SettingsCharm);
});
